/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import { View } from 'backbone.marionette';
import Backgrid from 'backgrid';
import 'psa-backgrid/BootstrapPaginator';

import PageableCollection from '../../backbone/PageableCollection';

import './GridView.css';

import tmplGridView from './GridView.hbs';

const GridView = View.extend({
  template: tmplGridView,

  regions: {
    grid: '.grid',
    paginator: '.paginator'
  },

  async initialize() {
    if (this.collection && _.isNil(this.options.collection)) {
      this.options.collection = this.collection;
    }
  },

  onRender() {
    if (this.options.collection instanceof PageableCollection) {
      this.getRegion('paginator').show(
        new Backgrid.Extension.Paginator({
          collection: this.options.collection
        })
      );
      this.getRegion('paginator').$el.find('ul').addClass('pagination-sm');
    }

    this.viewGrid = new Backgrid.Grid(this.options);

    this.showChildView('grid', this.viewGrid);

    if (this.options.width) {
      this.getRegion('grid').$el.find('table').css({
        width: this.options.width,
        'max-width': this.options.width
      });
    }
  },

  getViewGrid() {
    return this.viewGrid;
  },

  getColumns() {
    return this.options.columns;
  },

  focusOnGrid() {
    this.getRegion('grid').$el.find('table').focus();
  }
});

export default GridView;
